import { Action } from "@ngrx/store";

export const RESET_STATE = "[fhir] ResetState";
export const ADD = "[fhir] Add";
export const UPDATE = "[fhir] Update";
export const DELETE = "[fhir] Delete";
export const REPLACE = "[fhir] Replace";

export interface FhirPayload {
  resourceType: string;
  id: string;
  data?: {
    status?: string;
  };
}

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: FhirPayload) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: fhir.Resource) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: fhir.Resource) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: FhirPayload) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: FhirPayload) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/fhir.actions.ts